var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14003 12.36L3.36003 15.15C3.17003 15.35 3.17003 15.66 3.36003 15.86L6.14003 18.65C6.45003 18.97 6.99003 18.74 6.99003 18.3V16.5H13C13.55 16.5 14 16.05 14 15.5C14 14.95 13.55 14.5 13 14.5H6.99003V12.71C6.99003 12.26 6.45003 12.04 6.14003 12.36ZM20.65 9.14997L17.87 6.35997C17.56 6.03997 17.02 6.26997 17.02 6.70997V8.49997H11C10.45 8.49997 10 8.94997 10 9.49997C10 10.05 10.45 10.5 11 10.5H17.01V12.29C17.01 12.74 17.55 12.96 17.86 12.64L20.64 9.84997C20.84 9.65997 20.84 9.33997 20.65 9.14997Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRightArrow);
export default __webpack_public_path__ + "static/media/left-right-arrow.5c50977c.svg";
export { ForwardRef as ReactComponent };